// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Center, Loader, Stack, Text } from '@mantine/core';

interface LoadingOverlayProps {
  visible?: boolean;
  message?: string;
}

export function LoadingOverlay({
  visible = true,
  message,
}: LoadingOverlayProps) {
  if (!visible) return null;

  return (
    <Center
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 999,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
      }}
    >
      <Stack ta="center" gap="md">
        <Loader size="lg" />
        {message && (
          <Text c="dimmed" size="sm">
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  );
}
